import { render } from "./InviteLogin.vue?vue&type=template&id=64931e73&ts=true"
import script from "./InviteLogin.vue?vue&type=script&lang=ts"
export * from "./InviteLogin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__